import { useSelector, useDispatch } from 'react-redux';
import {
  nextRoundAction,
  setRoundWinUserAction,
  setRoundWinComputerAction,
  setRoundOneAction,
  setRoundTwoAction,
  setRoundThreeAction,
  setRoundFourAction,
  setRoundFiveAction,
  setRoundSixAction,
  setRoundSevenAction,
  setCurrentSimbolUserAction,
  setCurrentSimbolComputerAction,
  zeroingStateRoundAction,
} from './store/actions/roundActions';
import { setInfoAction, setAnimationAction } from './store/actions/infoActions';
import {
  addCountUserAction,
  addCountComputerAction,
} from './store/actions/scoreActions';

import { Header } from './layout/Header';
import { Field } from './layout/Field';
import { Footer } from './layout/Footer';

function App() {
  const dispatch = useDispatch();
  const roundCount = useSelector((state) => state.round.roundCount);
  const roundWinUser = useSelector((state) => state.round.roundWinUser);
  const roundWinComputer = useSelector((state) => state.round.roundWinComputer);
  const isAnimation = useSelector((state) => state.info.isAnimation);

  const nextRound = (result) => {
    dispatch(nextRoundAction(result));
  };

  const setRoundWinUser = (result) => {
    dispatch(setRoundWinUserAction(result));
  };

  const setRoundWinComputer = (result) => {
    dispatch(setRoundWinComputerAction(result));
  };
  const setRoundOne = (result) => {
    dispatch(setRoundOneAction(result));
  };
  const setRoundTwo = (result) => {
    dispatch(setRoundTwoAction(result));
  };

  const setRoundThree = (result) => {
    dispatch(setRoundThreeAction(result));
  };

  const setRoundFour = (result) => {
    dispatch(setRoundFourAction(result));
  };

  const setRoundFive = (result) => {
    dispatch(setRoundFiveAction(result));
  };

  const setRoundSix = (result) => {
    dispatch(setRoundSixAction(result));
  };

  const setRoundSeven = (result) => {
    dispatch(setRoundSevenAction(result));
  };

  const setCurrentSimbolUser = (result) => {
    dispatch(setCurrentSimbolUserAction(result));
  };

  const setCurrentSimbolComputer = (result) => {
    dispatch(setCurrentSimbolComputerAction(result));
  };

  const zeroingStateRound = (result) => {
    dispatch(zeroingStateRoundAction(result));
  };

  const setInfo = (result) => {
    dispatch(setInfoAction(result));
  };

  const setAnimation = (result) => {
    dispatch(setAnimationAction(result));
  };

  const addCountUser = (result) => {
    dispatch(addCountUserAction(result));
  };

  const addCountComputer = (result) => {
    dispatch(addCountComputerAction(result));
  };

  const handleRandomSign = () => {
    let rand = 1 - 0.5 + Math.random() * (3 - 1 + 1);
    if (Math.round(rand) === 1) {
      return 'rock';
    } else if (Math.round(rand) === 2) {
      return 'scissors';
    } else {
      return 'paper';
    }
  };

  const handleGovernmentRock = () => {
    if (!isAnimation) {
      setAnimation(true);
      setCurrentSimbolUser(0);
      setCurrentSimbolComputer(0);
      setInfo('...');
      let promise = new Promise((res) => {
        setTimeout(() => {
          setAnimation(false);
          res();
        }, 1000);
      });
      promise.then(() => {
        setCurrentSimbolUser(1);
        const comp = handleRandomSign();
        if (comp === 'rock') {
          setCurrentSimbolComputer(1);
          setInfo('Ничья, попробуйте ещё!');
        } else if (comp === 'scissors') {
          setCurrentSimbolComputer(2);
          setInfo('Вы выйграли :)');
          setRoundWinUser(1);
          handleRound(1);
          nextRound(1);
        } else {
          setCurrentSimbolComputer(3);
          setInfo('Вы проиграли :(');
          setRoundWinComputer(1);
          handleRound(2);
          nextRound(1);
        }
      });
    }
  };

  const handleGovernmentScissors = () => {
    if (!isAnimation) {
      setAnimation(true);
      setCurrentSimbolUser(0);
      setCurrentSimbolComputer(0);
      setInfo('...');
      let promise = new Promise((res) => {
        setTimeout(() => {
          setAnimation(false);
          res();
        }, 1000);
      });
      promise.then(() => {
        setCurrentSimbolUser(2);
        const comp = handleRandomSign();
        if (comp === 'scissors') {
          setCurrentSimbolComputer(2);
          setInfo('Ничья, попробуйте ещё!');
        } else if (comp === 'paper') {
          setCurrentSimbolComputer(3);
          setInfo('Вы выйграли :)');
          setRoundWinUser(1);
          handleRound(1);
          nextRound(1);
        } else {
          setCurrentSimbolComputer(1);
          setInfo('Вы проиграли :(');
          setRoundWinComputer(1);
          handleRound(2);
          nextRound(1);
        }
      });
    }
  };

  const handleGovernmentPaper = () => {
    if (!isAnimation) {
      setAnimation(true);
      setCurrentSimbolUser(0);
      setCurrentSimbolComputer(0);
      setInfo('...');
      let promise = new Promise((res) => {
        setTimeout(() => {
          setAnimation(false);
          res();
        }, 1000);
      });
      promise.then(() => {
        setCurrentSimbolUser(3);
        const comp = handleRandomSign();
        if (comp === 'paper') {
          setCurrentSimbolComputer(3);
          setInfo('Ничья, попробуйте ещё!');
        } else if (comp === 'rock') {
          setCurrentSimbolComputer(1);
          setInfo('Вы выйграли :)');
          setRoundWinUser(1);
          handleRound(1);
          nextRound(1);
        } else {
          setCurrentSimbolComputer(2);
          setInfo('Вы проиграли :(');
          setRoundWinComputer(1);
          handleRound(2);
          nextRound(1);
        }
      });
    }
  };

  const handleRound = (result) => {
    if (roundCount >= 1 && roundCount <= 7) {
      switch (roundCount) {
        case 1:
          setRoundTwo(3);
          return setRoundOne(result);
        case 2:
          setRoundThree(3);
          return setRoundTwo(result);
        case 3:
          setRoundFour(3);
          return setRoundThree(result);
        case 4:
          if (roundWinUser >= 3 && result === 1) {
            setInfo('Вы выйграли игру в чистую!');
            addCountUser(1);
            return zeroingStateRound(0);
          } else if (roundWinComputer >= 3 && result === 2) {
            setInfo('Вы проиграли игру в пух и прах!');
            addCountComputer(1);
            return zeroingStateRound(0);
          } else {
            setRoundFive(3);
            return setRoundFour(result);
          }
        case 5:
          if (roundWinUser >= 3 && result === 1) {
            setInfo('Вы выйграли игру! Ура!');
            addCountUser(1);
            return zeroingStateRound(0);
          } else if (roundWinComputer >= 3 && result === 2) {
            setInfo('Эх.. Вы проиграли игру!');
            addCountComputer(1);
            return zeroingStateRound(0);
          } else {
            setRoundSix(3);
            return setRoundFive(result);
          }
        case 6:
          if (roundWinUser >= 3 && result === 1) {
            setInfo('Вы выйграли игру! С победой!');
            addCountUser(1);
            return zeroingStateRound(0);
          } else if (roundWinComputer >= 3 && result === 2) {
            setInfo('Вы проиграли игру! Повезёт в следующий раз!');
            addCountComputer(1);
            return zeroingStateRound(0);
          } else {
          }
          setRoundSeven(3);
          return setRoundSix(result);
        case 7:
          if (roundWinUser >= 3 && result === 1) {
            setInfo('Вы выйграли игру! Это было не просто!');
            addCountUser(1);
            return zeroingStateRound(0);
          } else if (roundWinComputer >= 3 && result === 2) {
            setInfo('Вы проиграли игру! Чуть-чуть не повезло! ');
            addCountComputer(1);
            return zeroingStateRound(0);
          } else {
          }
          setRoundSeven(result);
          return zeroingStateRound(0);
        default:
          return roundCount;
      }
    } else {
      setInfo('Следующая игра');
      zeroingStateRound(0);
    }
  };

  return (
    <div className='App'>
      <Header />
      <Field />
      <Footer
        handleGovernmentRock={handleGovernmentRock}
        handleGovernmentScissors={handleGovernmentScissors}
        handleGovernmentPaper={handleGovernmentPaper}
      />
    </div>
  );
}

export default App;
